<template>
  <div class="basic-block block-other-contents-base" :style="styles">
    <div class="title-box">
      <h2>あの超有名占い師も<br>占いTVなら占い放題！</h2>
      <img class="title-line" src="/static/img/recommend/lp/touwa/lp_titleline.svg">
    </div>
    
    <div class="content-wrap">
      <div class="block-other-contents-base__inner">
       
        <div v-for="(item, idx) in profile" :key="idx" class="block-aother-contents-base__box">

          <div class="profile-box">
            <img class="profile-img" :src="item.img" :alt="item.name">
            <div class="profile-data">
              <h3>{{item.name}}</h3>
              <p class="lead">{{item.lead}}</p>
              <img class="profile-line" src="/static/img/recommend/lp/touwa/profile_line.svg">
              <p class="desc">{{item.desc}}</p>
            </div>
          </div>
          
          <div class="osusumelist">
            <p class="pickup">pickup!</p>
            <p class="pickup-title">おすすめ占い</p>
            <ul class="osusumelist-ul">
              <li class="osusumelist-li" v-for="(list,idx) in item.osusume" :key="idx">{{list}}</li>
            </ul>
          </div>

        </div>

        <p class="caption">※ご紹介している占いメニューは予告なく変更となる場合がございます。</p>
        
        <img class="teigaku-banner" src="/static/img/recommend/lp/touwa/teigaku_banner.png" alt="">
  

        <div class="btn-area">
          <span class="button-link" @click="clickedSubscSelect"><span class="button-face">登録して占う</span></span>
        </div>

      </div>
      
    </div>
   
  </div>
</template>

<script>

import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'



export default {
  name: 'BlockOhtercontents',
  components: {  
    LpBaseButton,

  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
   
    lpId: Number,
    subscUrl: String,
    gaTarget: String,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked () {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-free-shindan-button`,
      })
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
    clickedSubsc() {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-subsc-button`,
        'event_label': 'point2',
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
    clickedSubscSelect() {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}${this.gaTarget}-subsc-button`,
        'event_label': 'point2',
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
  },
  data(){
    return {
      profile:[
        {
          name:'水晶玉子',
          lead:'雑誌「FRaU」で人気爆発！',
          desc:'ゲッターズ飯田が「嫉妬する占い師」として、名前を挙げたことをきっかけに全国区で有名に。',
          img:'/static/img/recommend/lp/touwa/suishou_image.png',
          osusume:[
            `・水晶玉子が占う今日の運勢`,
            `・あの人があなたに運命を感じるとき`,
            `・あの人が運命の人である可能性`,
          ]
        },
        {
          name:'ステラ薫子',
          lead:'日本を代表する超大御所',
          desc:'西洋占星学、タロット占いの第一人者。嵐の大野智さん主演ドラマ「魔王」（2008年）では、キーアイテムであるタロットカードの監修をつとめたことでも話題に。',
          img:'/static/img/recommend/lp/touwa/sutera_image.png',
          osusume:[
            `・異性から見た私の印象って？`,
            `・2人の基本相性/恋愛相性/結婚相性`,
            `・2人が結婚したらどんな未来がある？`,
          ]
        },
        {
          name:'銀座の母（横田淑惠）',
          lead:'銀座に行列ができる占い師',
          desc:'手相、人相、九星、姓名判断、十二支占いなど、様々な占術に精通、ユニークなキャラクターがテレビで大人気に。',
          img:'/static/img/recommend/lp/touwa/ginza_image.png',
          osusume:[
            `・ここを磨けば、あなたはもっと光る！`,
            `・あなたはこういう仕事に向いてる！`,
            `・恨みつらみをスッキリさせるなら`,
          ]
        },
        

      ],
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

$uranaitv_black :#32373f;

.block-other-contents-base {
  background: #fff;
  padding: 40px 0 0;
  h2{
    font-style: normal;
    font-weight: 300;
    font-size: 22px;
    line-height: 30px;
    color: $uranaitv_black;
    margin:0;
    margin-bottom: 16px;
  }
  .title-box {
    text-align: center;
  }
  .title-line{
    margin-bottom: 24px;
  }
  
  

  &__inner {
    // padding: 0 20px 70px;
    padding: 0 20px 20px;
    background: #fff;
   
  }

  .profile-box{
    display: flex;
    max-width: 490px;
    margin: auto;
    margin-bottom: 16px;
  }
  .profile-data{
    h3{
      font-size: 10px;
      margin: 0;
      font-style: normal;
      font-weight: 300;
      font-size: 10px;
      line-height: 10px;
    }
  }
  .profile-img{
    margin-right: 8px;
    width: 90px;
    height: 110px;
  }
  .profile-line{
    display: block;
  }

  .lead{
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 26px;
    margin:0;
    margin-bottom: 8px;
  }
  .desc{
    margin: 0;
  }
  .osusumelist{
    background: #fff5f8;
    padding: 16px;
    border-radius: 10px;
    max-width: 490px;
    margin: auto;
    margin-bottom: 24px;
  }
  .osusumelist-ul{ 
    padding-left:0px;
    list-style: none;

  }
  .osusumelist-li{
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
  }
  .pickup{
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 10px;
    text-align: center;
    margin: 0;
    margin-bottom: 8px;
  }
  .pickup-title{
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 10px;
    text-align: center;
    margin: 0;
    margin-bottom: 16px;
  }
  .teigaku-banner{
    width: 100%;
    margin-bottom:24px;
  }
  .caption{
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    margin-bottom: 24px;
  }

  
  
  .baseButton {
    width: 80%;
    max-width: 382px;
    margin: auto;
    /deep/ {
      .baseButton__button--primary {
        background: #6799CB;
        .baseButton__button__label {
          color: #6799CB;
          &::after {
            background-color: #6799CB;
          }
        }
      }
    }
  }

}


.btn-area {
  max-width: 315px;
  margin: auto;
}
.button-link {
  min-width: 270px;
  max-width: 400px;
  margin: 0 auto;
  font-weight: bold;
  font-size: 16px;
  color: white;
  min-height: 55px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 100px;
  cursor: pointer;
  position:relative;
  background: $col_def_gradient;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  user-select: none;
  &::before {
    position:absolute;
    top:0;
    left:0;
    z-index:-1;
    box-sizing:border-box;
    border-radius:100px;
    padding:2px;
    width:100%;
    height:100%;
    background:#fff;
    background-clip:content-box;
    content:"";
  }
  .button-face {
    color: $col_temp_key1;
    background: $col_def_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    /deep/ {
      .notice,
      .face-body{
        display: block;
        width: 100%;
        color: $col_temp_key1;
        //グラデ方向崩れるため個別指定
        background: $col_def_gradient;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .notice {
        font-size: 0.8em;
        line-height: 1;
      }
    }
  }
  &.disable {
    pointer-events: none;
    background: #dcdfe2;
    .button-face {
      color: #dcdfe2;
      background: none;
      -webkit-text-fill-color: initial;
      -webkit-background-clip: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockOtherContents.vue